import React from 'react'
import { ServerConfig } from 'config'

import NonPaginatedList from '../../components/EntryListAndEdit/NonPaginatedList'


const TenantEcocontrols = () => {
  const non_editable_fields = [];

  const editable_fields = [
    ["id", "id", ""],
    ["owner", "Owner", "tenant"],
    ["secret", "Secret", ""],
    ["tenant_site_id", "Tenant Site ID", "tenantsite"],
    ["name", "Name"],
  ];

  return (
    <>
      <NonPaginatedList
        list_get_url={`${ServerConfig.SERVER_URL}/admin/ecocontrols`}
        detail_get_url={`${ServerConfig.SERVER_URL}/admin/ecocontrols/`}
        detail_put_url={`${ServerConfig.SERVER_URL}/admin/ecocontrols/`}
        add_new_url = {`${ServerConfig.SERVER_URL}/admin/ecocontrols/`}

        column_names={["id", "owner", "tenant_site_id", "name", "edit"]}
        header_names={["id", "owner", "tenant_site_id", "name", ""]}

        optional_column_names={["secret"]}
        optional_header_names={["Secret"]}

        editable_fields={editable_fields}
        non_editable_fields={non_editable_fields}
        //ledger_get_url = '/ledger/customer/'
        //show_machine_stats={true}
      />
    </>
  )
}

export default TenantEcocontrols
